import { object } from 'prop-types'
import React, { createContext, useCallback, useState } from 'react'

export const EditContext = createContext({})

const EditResourceProvider = ({ children }) => {
  const [resource, setResource] = useState({})

  const handleUseResource = resource => {
    setResource({
      assetType: parseInt(resource.assetType.id),
      businessOwnerId: resource.businessOwnerId,
      description: resource.shortDescription,
      categories: resource.categories.map(({ id }) => id),
      metaData: resource.metadata.map(({ name }) => name),
      resourceTitle: resource.title,
      subCategories: resource.subCategories.map(({ id }) => id),
      link: resource.url || '',
      // it appears that if a resource does not have an expiration date, it is saved in our db as 0001-01-01
      expiresOn:
        resource.expiresOn === '0001-01-01' ? null : resource.expiresOn,
      updatedOn: resource.updatedOn,
      id: resource.id,
    })
  }

  // without useCallback, function will change memory location every render
  // causing useEffect in EditResourceForm to go into infinite loop
  const clearResource = useCallback(() => setResource({}), [])

  return (
    <EditContext.Provider
      value={{
        clearResource,
        resource,
        setResource: handleUseResource,
      }}
    >
      {children}
    </EditContext.Provider>
  )
}

EditResourceProvider.propTypes = {
  children: object.isRequired,
}

export default EditResourceProvider
